<template>
  <el-table :data="tableData" :header-cell-style="{ background: '#41A1FF', color: '#fff' }" border
    height="calc(100vh - 204px)" style="width: 100%">
    <el-table-column prop="name" label="参会人" width="100" align="center" />
    <el-table-column prop="u_status" label="参会状态" width="90" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.u_status == 0">待开会</span>
        <span v-else-if="scope.row.u_status == 1">参加</span>
        <span v-else-if="scope.row.u_status == 2">请假</span>
        <span v-else-if="scope.row.u_status == 3">早退</span>
        <span v-else-if="scope.row.u_status == 4">拒绝</span>
        <span v-else-if="scope.row.u_status == 5">缺席</span>
        <span v-else-if="scope.row.u_status == 6">会议取消不需要开会</span>
        <span v-else-if="scope.row.u_status == 7">会议未进行</span>
        <span v-else></span>
      </template>
    </el-table-column>
    <el-table-column prop="sign_in_time" width="160" label="签到时间" align="center" />
    <el-table-column prop="sign_out_time" width="160" label="签退时间" align="center" />
    <el-table-column prop="speak_num" width="80" label="发言次数" align="center" />
    <el-table-column prop="speak_time" label="发言时间(分)" width="110" align="center" />
    <el-table-column prop="target_status" label="会议目标是否达成" width="140" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.target_status == 1">是</span>
        <span v-if="scope.row.target_status == 0">否</span>
      </template>
    </el-table-column>
    <el-table-column prop="problem_status" label="会议问题是否解决" width="140" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.problem_status == 1">是</span>
        <span v-if="scope.row.problem_status == 0">否</span>
      </template>
    </el-table-column>
    <el-table-column prop="score" width="150" label="会议评分" align="center">
      <template slot-scope="scope">
        <el-rate v-model="scope.row.score" disabled show-score text-color="#ff9900" score-template="{scope.row.score}" />
      </template>
    </el-table-column>
    <el-table-column prop="host_score" width="150" label="主持人评分" align="center">
      <template slot-scope="scope">
        <el-rate v-model="scope.row.host_score" disabled show-score text-color="#ff9900"
          score-template="{scope.row.host_score}" />
      </template>
    </el-table-column>
    <el-table-column prop="secretary_score" width="150" label="会议秘书评分" align="center">
      <template slot-scope="scope">
        <el-rate v-model="scope.row.secretary_score" disabled show-score text-color="#ff9900"
          score-template="{scope.row.secretary_score}" />
      </template>
    </el-table-column>
    <el-table-column prop="attendee_score" width="150" label="参会人评分" align="center">
      <template slot-scope="scope">
        <el-rate v-model="scope.row.attendee_score" disabled show-score text-color="#ff9900"
          score-template="{scope.row.attendee_score}" />
      </template>
    </el-table-column>
    <el-table-column prop="attendee_score" width="150" label="评分说明" align="left">
      <template slot-scope="scope">
        <el-popover v-if="scope.row.my_remark && scope.row.my_remark.length" placement="top-start" title="" width="200"
          trigger="hover">
          <section v-html="scoreDetail(scope.row.my_remark)"></section>
          <section slot="reference">
            <p v-html="showTableDetail(scope.row.my_remark)">
            </p>
          </section>
        </el-popover>
      </template>
    </el-table-column>
    <!-- <el-table-column prop="remark" label="备注" align="center"></el-table-column> -->
    <!-- <el-table-column prop="address" label="附件"></el-table-column> -->
  </el-table>
</template>
<script>
export default {
  name: 'ParticipationTable',
  props: {
    attendees: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    // console.log(this.attendees);

    return {
      tableData: []
    }
  },
  watch: {
    attendees(newValue, oldValue) {
      this.tableData = newValue.data.attendees
      console.log(this.tableData, '数据新')
    },
    deep: true

  },
  methods: {
    scoreDetail(arr) {
      return arr.reduce((p, v, index) => {
        return p += `${index > 0 ? '<div style="height:0;border-top:1px solid #EBEEF5;padding:4px"></div>' : ''}
        ${this.relpaceToken(v)}
        `
      }, ``)
    },
    relpaceToken(str) {
      if (str.includes('\n')) {
        return str.replaceAll('\n', '<br>')
      }
      //正则判断如果包含1,2,3序号,则插入换行
      if (str.match(/[1-9]\d*\、/gm)) {
        return str.replaceAll(/[1-9]\d*\、/gm, '<br>$&')
      }
      return str
    },
    showTableDetail(arr) {
      //截取三行
      let str = this.relpaceToken(arr[0]) 
      let strArr = str.split('<br>')
      let strArr1 = strArr.slice(0, 3)
      let str1 = strArr1.join('<br>')
      return str1 + '...'
    }
  },
}

</script>
<style scoped>
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
</style>
